import React from 'react';
import { ShieldCheckIcon, ThumbsUpIcon, StarIcon, UsersIcon } from 'lucide-react';
export const Guarantee = () => {
  return <section className="mb-10" data-id="element-202">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-203">
        Onze dubbele garantie
      </h2>
      <div className="bg-green-50 p-6 rounded-lg mb-8 border-2 border-green-200" data-id="element-204">
        <div className="flex items-start" data-id="element-205">
          <ShieldCheckIcon className="w-12 h-12 text-green-600 mr-4 flex-shrink-0" data-id="element-206" />
          <div data-id="element-207">
            <h3 className="text-lg font-bold text-green-800 mb-2" data-id="element-208">
              100% Tevredenheidsgarantie
            </h3>
            <p className="mb-4 leading-relaxed text-green-800" data-id="element-209">
              We zijn zo zeker van onze methode dat we een volledige
              geld-terug-garantie bieden.
            </p>
            <p className="mb-4 leading-relaxed text-green-800" data-id="element-210">
              Als je binnen dertig dagen niet tevreden bent over onze coaching,
              krijg je 100% van je investering terug.
            </p>
            <p className="mb-4 leading-relaxed text-green-800" data-id="element-211">
              Waarom we dit durven: Onze methode werkt omdat we de échte oorzaak
              aanpakken, niet alleen de symptomen.
            </p>
            <p className="text-sm text-green-700" data-id="element-212">
              De voorwaarden: Je moet het plan consequent volgen (wat we samen
              monitoren via dagelijkse check-ins).
            </p>
          </div>
        </div>
      </div>
      <div className="bg-green-50 p-6 rounded-lg mb-8 border-2 border-green-200" data-id="element-213">
        <div className="flex items-start" data-id="element-214">
          <ShieldCheckIcon className="w-12 h-12 text-green-600 mr-4 flex-shrink-0" data-id="element-215" />
          <div data-id="element-216">
            <h3 className="text-lg font-bold text-green-800 mb-2" data-id="element-217">
              Drie maanden resultaat garantie
            </h3>
            <p className="mb-4 leading-relaxed text-green-800" data-id="element-218">
              Als jouw hond binnen drie maanden geen dertig minuten alleen kan
              blijven krijg je gratis coaching totdat dit behaald is. Vanaf
              dertig minuten lukt het de meeste baasjes om zelfstandig verder te
              oefenen in stappen van 5 tot 10 minuten.
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-6 mb-8" data-id="element-219">
        <div className="flex items-start" data-id="element-220">
          <div className="mr-4 flex-shrink-0" data-id="element-221">
            <StarIcon className="w-8 h-8 text-yellow-500" data-id="element-222" />
          </div>
          <div data-id="element-223">
            <h3 className="font-bold text-lg mb-2" data-id="element-224">Track record</h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-225">
              <li data-id="element-226">100+ succesvolle trajecten in 2025</li>
              <li data-id="element-227">
                Gemiddelde rating: 4.9/5 sterren (gebaseerd op 633 reviews)
              </li>
            </ul>
          </div>
        </div>
        <div className="flex items-start" data-id="element-228">
          <div className="mr-4 flex-shrink-0" data-id="element-229">
            <UsersIcon className="w-8 h-8 text-blue-500" data-id="element-230" />
          </div>
          <div data-id="element-231">
            <h3 className="font-bold text-lg mb-2" data-id="element-232">Wie we zijn</h3>
            <p className="leading-relaxed" data-id="element-233">
              Stressless Dogs is opgericht door Amee Buijs, gespecialiseerd
              hondengedragstherapeut met jarenlange ervaring. Na jaren van
              frustratie met traditionele methodes voor verlatingsangst, heeft
              ze samen met verlatingsangst expert Sylvia een revolutionaire
              aanpak ontwikkelt die de onderliggende oorzaken aanpakt.
            </p>
            <p className="leading-relaxed mt-2" data-id="element-234">
              Ons team bestaat uit gecertificeerde hondengedragsspecialisten,
              allemaal gespecialiseerd in verschillende aspecten van
              angstgerelateerd gedrag.
            </p>
          </div>
        </div>
      </div>
      <div className="w-full mb-6" data-id="element-235">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n3fuJwQLVBD3xBKy3j4FXu/freepik__the-style-is-candid-image-photography-with-natural__77413.png" alt="Ontspannen hond op de bank terwijl eigenaar met boodschappen vertrekt" className="w-full h-auto rounded-lg shadow-md" data-id="element-236" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-237">
          "Ons doel is simpel: gelukkige honden en vrije baasjes"
        </p>
      </div>
    </section>;
};